type Props = {
  open: boolean;
  link: string;
  onClose: () => void;
  onCopy: () => void;
};

export function ShareModal({ open, link, onClose, onCopy }: Props) {
  if (!open) return null;
  return (
    <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-2xl w-96 text-center animate-pop-in border-4 border-blue-300">
        <h3 className="font-bold mb-2 text-blue-800">🔗 分享連結產生成功！</h3>
        <p className="text-xs text-gray-500 mb-4">將此連結傳給學生，他們打開就能使用這組題目</p>
        <textarea
          readOnly
          value={link}
          className="w-full h-24 p-2 border border-gray-300 rounded-lg text-xs break-all bg-gray-50 mb-4 focus:outline-none resize-none"
        />
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-200 py-2 rounded-lg text-gray-700 font-bold"
          >
            關閉
          </button>
          <button
            onClick={onCopy}
            className="flex-1 bg-blue-500 text-white py-2 rounded-lg font-bold hover:bg-blue-600"
          >
            複製連結
          </button>
        </div>
      </div>
    </div>
  );
}
